import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'mdk-card-detail',
  templateUrl: './card-detail.component.html',
  styleUrls: ['./styles/card-detail.component.mobile.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule, NgOptimizedImage]
})
export class CardDetailComponent {

  //#region [---- [INPUTS && OUTPUTS] ----]
  @Input() title: string;
  @Input() srcImg: string;
  @Input() srcButton: string;
  @Output() clickEvent: EventEmitter<void> = new EventEmitter();
  //#endregion

  //#region [---- [LOGIC] ----]
  public onClick(): void {
    this.clickEvent.emit();
  }
 }
